export default __webpack_public_path__ + "static/media/gesundheitpflegemono_light.aea3febd.png";